module.exports = __webpack_public_path__ + "img/correct.10468ba0.png";